import React from "react";
import Services from "../../api/service";
import { Link } from "react-router-dom";

const ServiceSection4 = (props) => {
  return (
    <section
      className={`wpo-department-section section-padding section-help ${props.dClass}`}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="wpo-section-title">
              <span>Como a Neurodesenvolver pode te ajudar?</span>
              <h2>Mais que Alfabetização: Uma Lição para a Vida.</h2>
              <p class="sub-text">
                Cada criança aprende no seu tempo, mas todas precisam de
                estímulos que respeitem não apenas o cérebro, mas também as
                emoções. É por isso que o Kit Neuroalfabetização foi construído
                sobre dois pilares essenciais e inseparáveis:
              </p>
            </div>
          </div>
        </div>
        <div className="department-wrap">
          <div className="department-doctor-wrap">
            <div className="row">
              {Services.slice(0, 8).map((service, sitem) => (
                <div className="col-lg-6 col-md-4 col-sm-6 col-12" key={sitem}>
                  <div className="department-single">
                    <div className="department-single-img">
                      <img src={service.Icon} alt="" />
                    </div>
                    <span>{service.title}</span>
                    <p class="sub-text-purple">{service.description}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="col-xl-12 col-lg-12 col-12 text-center">
              <Link onClick={props.link} className="theme-btn">
                QUERO MEU KIT COMPLETO
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceSection4;
